import { render } from "./TyreCardLoader.vue?vue&type=template&id=6206b195"
import script from "./TyreCardLoader.vue?vue&type=script&lang=js"
export * from "./TyreCardLoader.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__